export default __webpack_public_path__ + "static/media/mask3.22c5bc9e.png";